module.exports = __webpack_public_path__ + "img/download-on-the-app-store-fi.894fe300.svg";